module.exports = __webpack_public_path__ + "static/media/trio v shot 03.56dd4a30.webp";